import { CLEAR_STATE } from '../actions/session.actionTypes';

const cacheMeta = (reducer) => {
    return (state, action) => {
        switch (action.type) {
            case CLEAR_STATE:
                return reducer(undefined, action);
            default:
                return reducer(state, action);
        }
    };
};
export default cacheMeta;
